import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiTable
 * Display the semantic component Table with the corresponding mode
 * @param string id
 * @param bool celled: A table may be divided each row into separate cells.
 * @param array header: [{content, width: [1-16]}]
 * @param array content: [
 *  {
 *    key,
 *    id,
 *    active,
 *    positive,
 *    columns: [{
 *     content,
 *     verticalAlign, :[bottom, middle, top]
 *     textAlign, :[left, center, right]
 *     collapsing, : A cell can be collapsing so that it only uses as much space as required.
 *     width,: [1-16]
 *     colspan
 *    }]
 *  }]
 * @param sring bodyKey
 * @param sring mode
 */
export default class UiTable extends React.PureComponent {
  render() {
    const { header, content, bodyKey, mode, id, celled, basic } = this.props;
    const styleHeader = {};
    const styleTable = {};
    const styleRow = {};
    const styleRowActive = {};
    const styleRowPositive = {};
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      styleHeader.color = colors.TABLE_HEADER_COLOR;
      styleHeader.backgroundColor = colors.TABLE_HEADER_BACKGROUND_COLOR;
      styleTable.borderColor = colors.TABLE_HEADER_BACKGROUND_COLOR;
      styleTable.backgroundColor = 'inherit';
      styleRow.color = colors.TABLE_ROW_COLOR;
      styleRow.backgroundColor = colors.TABLE_ROW_BACKGROUND_COLOR;
      styleRowActive.color = colors.TABLE_ROW_ACTIVE_COLOR;
      styleRowActive.backgroundColor = colors.TABLE_ROW_ACTIVE_BACKGROUND_COLOR;
      styleRowPositive.backgroundColor =
        colors.TABLE_ROW_POSITIVE_BACKGROUND_COLOR;
    }
    const headerView = header.map((item, index) => {
      let headerCell = (
        <Table.HeaderCell style={styleHeader} key={index.toString()}>
          {item.content}
        </Table.HeaderCell>
      );
      headerCell = (
        <headerCell.type
          key={index.toString()}
          {...headerCell.props}
          {...(item.width ? { width: item.width } : {})}
        />
      );
      return headerCell;
    });
    let table = (
      <Table id={id} style={styleTable} celled={celled}>
        {header.length > 0 && (
          <Table.Header>
            <Table.Row key="headerRow">{headerView}</Table.Row>
          </Table.Header>
        )}
        <Table.Body key={bodyKey}>
          {content.length > 0 &&
            content.map((row, indexBody) => (
              <Table.Row
                key={row.key ? row.key : indexBody.toString()}
                id={row.id ? row.id : indexBody.toString()}
                style={{
                  ...styleRow,
                  ...(row.active ? styleRowActive : {}),
                  ...(row.positive ? styleRowPositive : {}),
                }}
              >
                {row.columns.length > 0 &&
                  row.columns.map((column) => {
                    let tableCell = <Table.Cell>{column.content}</Table.Cell>;
                    tableCell = (
                      <tableCell.type
                        {...tableCell.props}
                        {...(column.verticalAlign
                          ? { verticalAlign: column.verticalAlign }
                          : {})}
                        {...(column.textAlign
                          ? { textAlign: column.textAlign }
                          : {})}
                        {...(column.collapsing
                          ? { collapsing: column.collapsing }
                          : {})}
                        {...(column.width ? { width: column.width } : {})}
                        {...(column.colspan ? { colSpan: column.colspan } : {})}
                        {...(column.key ? { key: column.key } : {})}
                      />
                    );
                    return tableCell;
                  })}
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    );
    if (basic) {
      table = <table.type {...table.props} {...{ basic: 'very' }} />;
    }
    return table;
  }
}

UiTable.propTypes = {
  id: PropTypes.string,
  basic: PropTypes.bool,
  celled:
    PropTypes.bool /* A table may be divided each row into separate cells */,
  header: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.node,
      width: PropTypes.number,
    })
  ),
  content: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      id: PropTypes.string,
      active: PropTypes.bool,
      positive: PropTypes.bool,
      columns: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.node,
          verticalAlign: PropTypes.string,
          textAlign: PropTypes.string,
          collapsing: PropTypes.bool,
          width: PropTypes.number,
          colspan: PropTypes.number,
        })
      ),
    })
  ),
  bodyKey: PropTypes.string,
  mode: PropTypes.string,
};

UiTable.defaultProps = {
  celled: false,
  header: [],
  content: [],
  bodyKey: '',
  mode: null,
  id: '',
  basic: false,
};
